import ToggleBtn from "../Services/ToggleBtn";

const FreeParkingInput = ({ value, onChange }) => {
    return (
        <div className="input-group border-b-[1.5px] py-3 h-[90px]">
            <label className="block text-sm">Free Parking</label>
            <div className="flex items-center gap-3 mt-3">
                <ToggleBtn
                    serviceName="has_free_parking"
                    initialIsOn={value}
                    onToggle={(_, isOn) => onChange(isOn)}
                />
                <span className="text-[#737880]">
                    {value
                        ? "Free parking is available"
                        : "Free parking is not available"}
                </span>
            </div>
        </div>
    );
};

export default FreeParkingInput;
